/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { DotNetRequestMessageService } from '@mep/web-browser-bridge';
import { GlobalConstants } from '../../../../feature/src/lib/constants/global-constants';
import { Observable, from, of } from "rxjs";
import { AddFamilyInformationReturnCodes, InputData, ServiceType } from "../../../../feature/src/lib/models/family-information-model";
import { IFamilyInformationItem } from "../../../../feature/src/lib/components/add-family-information/add-family-information-types";
import { DeviceEquipmentDetailsDataToApply, DeviceEquipmentDetailsInputData } from 'libs/sysque/toolbelt/feature/src/lib/models/device-equipment-details-return-codes';

@Injectable({
  providedIn: 'root',
})
export class FamilyInformationService {
  constructor(private messageHandler: DotNetRequestMessageService) { }

  public getAddFamilyInformationDialogType(data: InputData): Observable<string> {
    return from<Promise<string>>(this.messageHandler.sendRequestAsync(GlobalConstants.GET_ADD_FAMILY_INFORMATION_DIALOG_TYPE, [data]));
  }

  public saveFamilyInformationInXml(item: IFamilyInformationItem): Observable<string> {
    return from<Promise<string>>(this.messageHandler.sendRequestAsync(GlobalConstants.SAVE_FAMILY_INFORMATION_IN_XML, [item]));
  }

  public changeDialogDimensions(height: number): Observable<void> {
    return from<Promise<void>>(this.messageHandler.sendRequestAsync(GlobalConstants.ChangeDialogDimensions, [height]));
  }

  public getPdfLocationPath(): Observable<string> {
    return from<Promise<string>>(this.messageHandler.sendRequestAsync(GlobalConstants.GET_PDF_LOCATION_PATH_METHOD_NAME));
  }

  public openPdfFile(path: string): Observable<AddFamilyInformationReturnCodes> {
    return from<Promise<AddFamilyInformationReturnCodes>>(this.messageHandler.sendRequestAsync(GlobalConstants.OPEN_PDF_FILE_METHOD_NAME, [path]));
  }

  public sendClosePopupAction(): Observable<void> {
    return from<Promise<void>>(this.messageHandler.sendRequestAsync(GlobalConstants.OnCloseWindow));
  }

  public saveServiceType(serviceType: ServiceType): Observable<string> {
    return from<Promise<string>>(this.messageHandler.sendRequestAsync(GlobalConstants.SAVE_SERVICE_TYPE, [serviceType]));
  }

  public deleteServiceType(serviceType: ServiceType): Observable<string> {
    return from<Promise<string>>(this.messageHandler.sendRequestAsync(GlobalConstants.DELETE_SERVICE_TYPE, [serviceType]));
  }

  public getUserCustomImage(systemName: string, name: string): Observable<string> {
    return from<Promise<string>>(this.messageHandler.sendRequestAsync(GlobalConstants.GET_USER_CUSTOM_IMAGE_METHOD_NAME, [systemName, name]));
  }

  public validateAndGetData(): Observable<DeviceEquipmentDetailsInputData> {
    return from<Promise<DeviceEquipmentDetailsInputData>>(this.messageHandler.sendRequestAsync(GlobalConstants.VALIDATE_AND_GET_DATA_METHOD_NAME));
  }

  public deviceEquipmentDetailsApplyData(data: DeviceEquipmentDetailsDataToApply): Observable<void> {
    return from<Promise<void>>(this.messageHandler.sendRequestAsync(GlobalConstants.DEVICE_EQUIPMENT_DETAILS_APPLY_DATA_METHOD_NAME, [data]));
  }
}
